const closeNoticeButton = document.querySelector(".close-notice-button");

if (closeNoticeButton) {
    const noticeWrapper = document.querySelector(".woocommerce-notices-wrapper");
    setTimeout(() => {
        noticeWrapper.classList.add("active");
    }, 500);

    closeNoticeButton.addEventListener("click", (e) => {
        e.preventDefault();
        noticeWrapper.classList.remove("active");

        setTimeout(() => {
            noticeWrapper.remove();
        }, 500);
    });
}
